import { render, staticRenderFns } from "./TopicFooter.vue?vue&type=template&id=10b22cea&scoped=true&"
import script from "./TopicFooter.vue?vue&type=script&lang=js&"
export * from "./TopicFooter.vue?vue&type=script&lang=js&"
import style0 from "./TopicFooter.vue?vue&type=style&index=0&id=10b22cea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b22cea",
  null
  
)

export default component.exports